import React, { useState } from 'react'
import classes from "./style.module.scss"
import useStyles from "isomorphic-style-loader/useStyles"
import { Swiper, SwiperSlide } from 'swiper/react'
import DetailsVideo from './video/details-video'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { videos, positionChange, floatingVideoClickHandle, viewMoreHandle } = props

    const [activeVideoIndex, setActiveVideoIndex] = useState(0)
    const [swiper, setSwiper] = useState(null)
    const [muted, setMuted] = useState(true)

    const endedHandle = () => {
        if (swiper) {
            if (activeVideoIndex + 1 <= videos.length - 1) {
                swiper.slideNext()
                setActiveVideoIndex(activeVideoIndex + 1)
            } else {
                swiper.slideTo(0, 0)
                setActiveVideoIndex(0)
            }
        } else {
            console.log('ended')
        }
    }

    const slideChangeHandle = (sw) => {
        positionChange?.(sw.activeIndex)
    }

    const handleVideoClick = (index, video) => {
        // youtubeId
        floatingVideoClickHandle(index, video)
        if(window.GeekoSensors){
            window.GeekoSensors.Track("FragmentsVideoClick",{
                video_id: video?.youtubeId,
                video_position: index
            })
        }
    }


    const handleViewMore = e => {
        viewMoreHandle(e)
        if(window.GeekoSensors){
            window.GeekoSensors.Track("FragmentsVideoViewMore",{
               
            })
        }
    }

    return <div className={classes.Container}>
        <div className={classes.Bd}>
            <Swiper className={classes.VideoSwiper} onSwiper={setSwiper} spaceBetween={8} slidesPerView="auto" onSlideChange={slideChangeHandle}>
                {
                    videos?.slice(0, 5).map((video, index) => {
                        return <SwiperSlide key={index} className={classes.VideoSwiperSlide}>
                            <div className={classes.VideoContainer}>
                                <DetailsVideo clickHandle={() => handleVideoClick(index, video)} setMuted={setMuted} muted={muted} video={video} endedHandle={endedHandle} shouldPlay={activeVideoIndex === index} />
                            </div>
                        </SwiperSlide>
                    })
                }
                {
                    videos.length > 5 && <SwiperSlide className={classes.ViewMore} onClick={handleViewMore}>
                        <FormattedMessage id="view_more" defaultMessage="View More" /> {">"}
                    </SwiperSlide>
                }
            </Swiper>
        </div>
    </div>
}